import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset scroll position to top whenever the URL path changes.
 * Essential for SPA navigation where the viewport might stay at the bottom of the previous long page.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll to top
    window.scrollTo(0, 0);
    
    // Some browsers or layouts (like those with transitions) might benefit from a secondary micro-task scroll
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
